import { Button, Alert, AlertIcon, AlertTitle, AlertDescription, CloseButton } from "@chakra-ui/react";
import React, { useState } from "react";

export const AddTokenButton = () => {
  const [alertVisible, setAlertVisible] = useState(false);

  const handleAddToken = async () => {
    try {
      const { ethereum } = window as any;
      if (ethereum && ethereum.isMetaMask) {
        const wasAdded = await ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20',
            options: {
              address: "0x0c3B13f9D5156d1195644852661bA61ae53A423C",  // Token address
              symbol: "ARY",  // Token symbol
              decimals: 18,  // Number of decimals
              image: "https://aarya.network/images/logo-32x32.png",  // Token logo URL
            },
          },
        });

        if (wasAdded) {
          console.log('Token added successfully!');
        } else {
          console.log('Failed to add token.');
        }
      } else {
        setAlertVisible(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseAlert = () => {
    setAlertVisible(false);
  };

  const alertOverlayStyle: React.CSSProperties = {
    position: "fixed",
    top: "10%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 9999, // Ensure the alert is on top of other content
  };

  return (
    <>
      <Button
        borderRadius="xl"
        backgroundColor="#eb692d"
        onClick={handleAddToken}
      >
        Add Token
      </Button>
      {alertVisible && (
        <div style={alertOverlayStyle}>
          <Alert status="error" borderRadius="xl" p={4}>
            <AlertIcon />
            <AlertTitle mr={2}>MetaMask is not installed</AlertTitle>
            <AlertDescription>Please install MetaMask to perform this action.</AlertDescription>
            <CloseButton onClick={handleCloseAlert} position="absolute" right="8px" top="8px" />
          </Alert>
        </div>
      )}
    </>
  );
};
